(function () {
  const ROOT_SELECTOR = 'main[data-template="product"]';
  const VIDEO_SELECTOR = '.pairfit-pdp-video--inline video';

  function isDesktopColumns(gallery) {
    return (
      window.matchMedia('(min-width: 750px)').matches &&
      gallery?.dataset.desktopLayout === 'columns'
    );
  }

  function prepareVideo(video) {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.controls = false;
    video.playsInline = true;
    video.preload = 'auto';
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');
    video.removeAttribute('controls');
  }

  function playInlineVideo(video) {
    if (!video) return;

    prepareVideo(video);

    const attemptPlay = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    if (video.readyState >= 2) {
      attemptPlay();
    } else {
      video.addEventListener('loadeddata', attemptPlay, { once: true });
      video.addEventListener('canplay', attemptPlay, { once: true });
    }

    attemptPlay();
  }

  function pauseInlineVideos(root, except) {
    root.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
      if (except && video === except) return;
      if (!video.paused) video.pause();
    });
  }

  function activateSlideVideo(slide) {
    if (!slide) return;

    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const inlineWrap = slide.querySelector('.pairfit-pdp-video--inline');
    const video = inlineWrap?.querySelector('video');

    pauseInlineVideos(root, video);

    if (!video) return;
    playInlineVideo(video);
  }

  function isMostlyVisible(el, scrollRoot) {
    const rect = el.getBoundingClientRect();
    if (rect.height < 8 || rect.width < 8) return false;

    const rootBox = scrollRoot
      ? scrollRoot.getBoundingClientRect()
      : { top: 0, bottom: window.innerHeight, left: 0, right: window.innerWidth };

    const visibleHeight = Math.min(rect.bottom, rootBox.bottom) - Math.max(rect.top, rootBox.top);
    const visibleWidth = Math.min(rect.right, rootBox.right) - Math.max(rect.left, rootBox.left);
    if (visibleHeight <= 0 || visibleWidth <= 0) return false;

    return visibleHeight / rect.height >= 0.25;
  }

  function playVisibleVideos(root) {
    root.querySelectorAll(VIDEO_SELECTOR).forEach((video) => {
      if (isMostlyVisible(video)) {
        playInlineVideo(video);
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function initViewportVideos(root) {
    const wraps = root.querySelectorAll('.pairfit-pdp-video--inline');
    if (!wraps.length) return null;

    wraps.forEach((wrap) => prepareVideo(wrap.querySelector('video')));

    const sync = () => playVisibleVideos(root);

    const observer = new IntersectionObserver(() => sync(), {
      threshold: [0, 0.25, 0.5, 0.75],
    });

    wraps.forEach((wrap) => observer.observe(wrap));
    window.addEventListener('scroll', sync, { passive: true });
    sync();
    return observer;
  }

  function initMobileSlideVideos(gallery) {
    const run = () =>
      activateSlideVideo(
        gallery.querySelector('.product__media-item.is-active') || gallery.querySelector('.product__media-item')
      );

    run();
    window.setTimeout(run, 250);
    window.setTimeout(run, 800);

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', (event) => {
        activateSlideVideo(event.detail.currentElement);
      });
    }

    gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]').forEach((thumb) => {
      thumb.querySelector('button')?.addEventListener('click', () => {
        window.setTimeout(() => {
          const mediaId = thumb.dataset.target;
          const slide = gallery.querySelector(`[data-media-id="${mediaId}"]`);
          activateSlideVideo(slide);
        }, 50);
      });
    });
  }

  function initPairfitProductVideos() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    const gallery = root.querySelector('media-gallery');
    if (!gallery) return;

    root.querySelectorAll(VIDEO_SELECTOR).forEach(prepareVideo);

    if (root.dataset.pairfitVideoInit === 'true') {
      if (isDesktopColumns(gallery)) playVisibleVideos(root);
      return;
    }

    root.dataset.pairfitVideoInit = 'true';

    const start = () => {
      if (isDesktopColumns(gallery)) {
        initViewportVideos(root);
      } else {
        initMobileSlideVideos(gallery);
      }
    };

    start();

    const mediaQuery = window.matchMedia('(min-width: 750px)');
    mediaQuery.addEventListener('change', () => {
      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPairfitProductVideos);
  } else {
    initPairfitProductVideos();
  }

  window.addEventListener('load', initPairfitProductVideos);
  document.addEventListener(
    'pointerdown',
    () => {
      const root = document.querySelector(ROOT_SELECTOR);
      const gallery = root?.querySelector('media-gallery');
      if (!root || !gallery || !isDesktopColumns(gallery)) return;
      playVisibleVideos(root);
    },
    { once: true, passive: true }
  );
})();
